import { Modelo } from '@ext/index';
import moment, { Moment } from 'moment';
import { isObject } from 'util';
import { Viajante } from '@/__env/lib/Ventas/Viajantes/Viajante.nav';
import { Articulo } from '@/__env/lib/Articulos';
import * as Pedidos from '../';


export class IResumenPublicacionesMercadoLibre extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Cuenta: string;
    public Datos: IEstadiscia = {}

    public set(): boolean
    {

        this.Datos = this.Json;

        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IResumenPublicacionesMercadoLibre )
    {
        this.Model = Model;
    }
    public Model: IResumenPublicacionesMercadoLibre;
}


export interface IEstadiscia
{
    activas?: Activas;
    pausadas?: Pausadas;
    cerradas?: Cerradas;
}

export interface Ados
{
    total?: number;
}

export interface Activas
{
    total?: number;
    detalles?: ActivasDetalles;
}

export interface Pausadas
{
    total?: number;
    detalles?: PausadasDetalles;
}

export interface Cerradas
{
    total?: number;
}

export interface ActivasDetalles
{
    con_error_codigo?: number;
    financiadas?: number;
    contado?: number;
    en_falta?: number;
    precio_menor_mayorista?: number;
    no_actualizo_stock_75?: number;
    actualizo_stock_75?: number;
    bajo_stock?: number;
    precio_financiado_error?: number;
}


export interface PausadasDetalles
{
    con_error_codigo?: number;
    financiadas?: number;
    contado?: number;
    pausado_por_faltante?: number;
    pausado_por_stock_cero?: number;
    disponible_para_reactivar?: number;
}